import React from "react";
import useDeviceOrderDetailApi from "@apis/useDeviceOrderDetailApi";
import useOverview from "@util/hook/useOverview";
import { OverviewListLayout } from "@icoach/components";
import BillingRecordRowsLabel from "@icoach/memberDetail/components/BillingRecordRowsLabel";

/**
 * [元件] 會員詳細頁 > 智能系統 > 扣款紀錄
 *
 * - 呼叫 API 取得扣款資料（useDeviceOrderDetailApi）
 * - 使用 useOverview 控制資料取得與分頁
 * - 使用 OverviewListLayout 統一列表樣式
 *
 * @component
 * @param {{ memberID: string }} props - 當前會員 ID
 */
const MemberDetailSmartFitnessBandContentBillingRecord = (props) => {
	const { postDeviceOrderDetailOrderApi } = useDeviceOrderDetailApi();
	const { overviewData, updateOverviewPage } = useOverview({
		getOverviewApi: postDeviceOrderDetailOrderApi,
		defaultSearchParams: {
			memberID: props.memberID,
			pageIndex: 1,
			pageSize : 50,
		},
		isFetchOnMount: true,
		enableInfiniteScroll: false,
		enableQueryString: false
	});
	const { list = [], pagination } = overviewData || {};

	return (
		<OverviewListLayout>
			<OverviewListLayout.Summary
				className={'mb-2 py-0'}
				pageSortAndTotalProps={{
				pageSize: pagination?.pageSize,
				pageIndex: pagination?.pageIndex,
				totalCount: pagination?.totalCount,
			}} />
			<OverviewListLayout.Table headerRow={BillingRecordRowsLabel} list={list} pageIndex={pagination?.pageIndex} totalPage={pagination?.totalPage} onChangePage={(e, pageIndex) => updateOverviewPage(pageIndex)} isPagination isGray />
		</OverviewListLayout>
	);
};

export default MemberDetailSmartFitnessBandContentBillingRecord;
